// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Settings-Bom3Settings-module__box--J_Zww {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 40px;
}
.src-businessServices-services-bsBom3-Bom3Settings-Bom3Settings-module__box--J_Zww h3 {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  margin: 12px 0 0 0;
}
.src-businessServices-services-bsBom3-Bom3Settings-Bom3Settings-module__labelBox--ihMIK label {
  display: inline-flex;
  gap: 8px;
  cursor: pointer;
}
.src-businessServices-services-bsBom3-Bom3Settings-Bom3Settings-module__footer--Jexrb {
  height: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Settings/Bom3Settings.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AACF;AALA;EAOI,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;AAGA;EAEI,oBAAA;EACA,QAAA;EACA,eAAA;AAFJ;AAMA;EACE,YAAA;AAJF","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 40px; // footer\n\n  h3 {\n    color: rgba(0, 0, 0, 0.85);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 160%;\n    margin: 12px 0 0 0;\n  }\n}\n\n.labelBox {\n  label {\n    display: inline-flex;\n    gap: 8px;\n    cursor: pointer;\n  }\n}\n\n.footer {\n  height: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsBom3-Bom3Settings-Bom3Settings-module__box--J_Zww`,
	"labelBox": `src-businessServices-services-bsBom3-Bom3Settings-Bom3Settings-module__labelBox--ihMIK`,
	"footer": `src-businessServices-services-bsBom3-Bom3Settings-Bom3Settings-module__footer--Jexrb`
};
export default ___CSS_LOADER_EXPORT___;
